import Products from "./products";
import { useNavigate } from "react-router-dom";
import { Calendars } from "./calendars";
import PaymentVids from "./payment-vids";
import Rooms from "./rooms";
import Ctrls from "./ctrls";
import Agents from "./agents";
import Channels from "./channels";
import Patterns from "./patterns";
import Company from "./company";
import Requisites from "./requisites";
import Users from "./users/users";
import Tokens from "./tokens";
import ReportDesigns from "./report-designs/report-designs";
import Catalogs from "./catalogs";
import Tags from "./tags/tags";
import Cards from "./cards";
import { useEffect, useRef, useState } from "react";
import { message, Select } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { licenseModuleBase, licenseModuleAccessControl, licenseModuleWidget, licenseModuleMessages } from "@/extensions";
import { serverFetch } from "@/server";
import { isMobile } from "@/extensions/design";
import SettingsFilter from "./settings-filter";

const Settings = ({ page, hideMenu = false }) => {
  const [company, setCompany] = useState();
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState();
  const pageRef = useRef(null);
  const [headerModified, setHeaderModified] = useState(false);
  const [headerLoading, setHeaderLoading] = useState(false);
  const [headerValid, setHeaderValid] = useState(true);
  const activeLicenseModules = company?.activeLicense?.activeModules;

  useEffect(() => {
          serverFetch(`company/current`)
              .then(data => setCompany(data))
              .catch(e => message.error(e.userMessage));
  }, [])

  useEffect(() => {
    setHeaderModified(false);
    setHeaderLoading(false);
    setHeaderValid(true);
  }, [page]);

  const hasActiveLicense = licenseModuleBase(activeLicenseModules);

  const pagesMobile = [
    { title: "Компания", link: "company" },
    { title: "Реквизиты", link: "requisites" },
    { title: "Номенклатура", link: "products" },
    { title: "Пользователи", link: "users" },
  ];

  const showHeaderSave = isMobile && (page === "company" || page === "requisites");

  const handlePageChange = (newPage) => {
    navigate(`/settings/${newPage}`);
  };

  const onHeaderSave = () => {
    if (pageRef.current?.save) {
      pageRef.current.save();
    }
  };

  const getPage = () => {
    const refCallback = (instance) => {
      pageRef.current = instance;
    };
    if (!hasActiveLicense) {
      if (page === "users") return <Users />;
      return <Company ref={refCallback} onHeaderStateChange={setHeaderModified} onHeaderLoadingChange={setHeaderLoading} onValidityChange={setHeaderValid} />;
    }
    switch (page) {
      case "products": return <Products filter={filter} />
      case "calendars": return <Calendars />
      case "company": return <Company ref={refCallback} onHeaderStateChange={setHeaderModified} onHeaderLoadingChange={setHeaderLoading} onValidityChange={setHeaderValid} />
      case "paymentvids": return <PaymentVids />
      case "rooms": return <Rooms />
      case "ctrls": return <Ctrls />
      case "agents": return <Agents />
      case "channels": return <Channels />
      case "patterns": return <Patterns />
      case "users": return <Users />
      case "tokens": return <Tokens />
      case "reports": return <ReportDesigns />
      case "catalogs": return <Catalogs />
      case "tags": return <Tags />
      case "cards": return <Cards />
      case "requisites": return <Requisites ref={refCallback} onHeaderStateChange={setHeaderModified} onHeaderLoadingChange={setHeaderLoading} />;
      default: return null;
    }
  };

  const getItem = (title, link, id) => <a id={id} className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} href={`/settings/${link}`}>{title}</a>;

  return !isMobile ? (<div className="col-one-main settings-main">
    {!hideMenu && <div className="col-one-title">
      {getItem("Компания", "company", "tour-item-settings-company")}
      {getItem("Пользователи", "users", "tour-item-settings-menu-users")}
      {hasActiveLicense && (
        <>
          {licenseModuleWidget(activeLicenseModules) ? getItem("Каталог", "catalogs") : null}
          {getItem("Календари", "calendars", "tour-item-settings-menu-calendars")}
          {licenseModuleAccessControl(activeLicenseModules) ? getItem("Контроллеры", "ctrls") : null}
          {licenseModuleMessages(activeLicenseModules) ? getItem("Агенты", "agents") : null}
          {licenseModuleMessages(activeLicenseModules) ? getItem("Каналы", "channels") : null}
          {getItem("Интеграция", "tokens", "tour-item-settings-menu-tokens")}
          {getItem("Отчеты", "reports", "tour-item-settings-menu-reports")}
        </>
      )}
    </div>}
    <div className="col-one-col">{getPage()}</div>
  </div>) : (
    <div className="sport-form-content">
      <div className="col-one-main">
        <div className="col-one-col">
          <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Настройки</div>
          <div className='selector-filer-section'>
            <Select value={page} onChange={handlePageChange} style={{ width: "100%" }}>
              {pagesMobile.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            {showHeaderSave && (
              <SaveOutlined
                title="Сохранить"
                style={{
                  color: headerModified && !headerLoading && headerValid ? "#2f6f00" : "#999",
                  fontSize: 20,
                  marginLeft: 8,
                  cursor: headerModified && !headerLoading && headerValid ? "pointer" : "not-allowed",
                  opacity: headerModified && !headerLoading && headerValid ? 1 : 0.4,
                }}
                onClick={() => headerModified && !headerLoading && headerValid && onHeaderSave()}
              />
            )}
            {page === "products" ?
              (<img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)} />) :
              (<></>)}
            {showFilter && <SettingsFilter value={filter} activePage={page} onClose={(filters) => { setShowFilter(false); if (filters) setFilter(filters); }} />}
          </div>
          {getPage()}
        </div>
      </div>
    </div>
  );
};

export default Settings;
